import { defineStore } from 'pinia'

type State = {
  rerenderKey: number
}

const getDefaultState = (): State => ({
  rerenderKey: 1,
})

export const useDevStore = defineStore('dev', {
  state: getDefaultState,

  actions: {
    INCREMENT_RERENDER_KEY() {
      this.rerenderKey++
    },

    forceRerender() {
      this.INCREMENT_RERENDER_KEY()
    },
  },
})
